import { Button, Space, Table, Tag } from "antd";
import { dateFormat } from "../../../core/utils/date-utils";
import { billingStatusColor, billingStatusKey } from "../../../enums/ReportBillingStatusEnum";

/**
 * Mutabakat sonucunun tek kovası, antd Collapse'ın `items` biçiminde.
 *
 * Bileşen DEĞİL fabrika: Collapse çocuklarını klonlayıp isActive/panelKey gibi propları enjekte
 * ediyor; araya özel bir bileşen koyulursa bu proplar alt Panel'e ulaşmaz ve panel açılıp kapanmaz.
 *
 * Önizleme sunucudan sınırlı gelir; toplu aksiyon önizlemeye DEĞİL, sunucuda yeniden türetilen tam
 * kovaya uygulanır — başlıktaki adet gerçek adettir.
 */
export default function buildBucketItem({
    t, bucket, title, description, actionLabel, onAction, onExport, busy,
}) {
    const count = bucket?.count || 0;
    const preview = bucket?.preview || [];
    const isSystemBucket = preview.some(x => x.reportId);

    const columns = isSystemBucket
        ? [
            { title: 'Id', dataIndex: 'reportId', key: 'reportId', width: 90 },
            { title: t('Accession No'), dataIndex: 'accessionNumber', key: 'accessionNumber', width: 140 },
            { title: t('Patient'), dataIndex: 'patientName', key: 'patientName', width: 160 },
            { title: t('Request Name'), dataIndex: 'requestName', key: 'requestName' },
            {
                title: t('Confirm Date'),
                dataIndex: 'confirmDate',
                key: 'confirmDate',
                width: 130,
                render: (text) => (text ? dateFormat(text) : '-')
            },
            {
                title: t('Billing Status'),
                dataIndex: 'billingStatus',
                key: 'billingStatus',
                width: 140,
                render: (text) => <Tag color={billingStatusColor(text)}>{t(billingStatusKey(text))}</Tag>
            },
        ]
        : [
            { title: t('Accession No'), dataIndex: 'accessionNumber', key: 'accessionNumber' },
        ];

    return {
        key: String(bucket?.bucket ?? title),
        label: (
            <Space>
                <b>{title}</b>
                <Tag color={count > 0 ? 'blue' : 'default'}>{count}</Tag>
                <span style={{ fontSize: 12, color: 'var(--text-2)' }}>{description}</span>
            </Space>
        ),
        extra: (
            // Başlıktaki butona tıklamak paneli açıp kapatmasın.
            <Space onClick={(e) => e.stopPropagation()}>
                {onExport && (
                    <Button size={'small'} disabled={count === 0 || busy} onClick={onExport}>
                        {t('Excel')}
                    </Button>
                )}
                {onAction && (
                    <Button size={'small'} type={'primary'} disabled={count === 0 || busy} onClick={onAction}>
                        {actionLabel}
                    </Button>
                )}
            </Space>
        ),
        children: (
            <>
                <Table
                    size={'small'}
                    rowKey={(record, index) => `${record.reportId || record.accessionNumber}-${index}`}
                    dataSource={preview}
                    columns={columns}
                    pagination={false}
                    scroll={{ y: 240 }}
                />
                {count > preview.length && (
                    <div style={{ marginTop: 8, fontSize: 12, color: 'var(--text-2)' }}>
                        {t('Preview')}: {preview.length} / {count}
                    </div>
                )}
            </>
        ),
    };
}
